import { Box, Group, Text } from '@mantine/core';
import {
  Icon,
  IconAlertTriangle,
  IconCircleCheck,
  IconCircleX,
  IconClock,
} from '@tabler/icons-react';
import { ModelOutcome, OutcomeStatus } from './modelOutcome';

// Each state differs in icon shape as well as colour, so it reads without colour.
export const STATUS_STYLE: Record<OutcomeStatus, { icon: Icon; colour: string }> = {
  lasts: { icon: IconCircleCheck, colour: 'success' },
  shortLate: { icon: IconAlertTriangle, colour: 'warning' },
  shortEarly: { icon: IconCircleX, colour: 'error' },
  notProjected: { icon: IconClock, colour: 'gray' },
};

export function OutcomeVerdict({ outcome }: { outcome: ModelOutcome }) {
  const { icon: StatusIcon, colour } = STATUS_STYLE[outcome.status];
  const muted = outcome.status === 'notProjected';
  return (
    <Group gap="xxs" wrap="nowrap" align="flex-start" data-testid="model-outcome">
      <StatusIcon
        size={20}
        stroke={1.75}
        color={`var(--mantine-color-${colour}-${muted ? 5 : 7})`}
        style={{ flexShrink: 0 }}
        aria-hidden
      />
      <Box miw={0}>
        <Text size="sm" fw={600} c={muted ? 'dimmed' : `${colour}.8`}>
          {outcome.verdict}
        </Text>
        {outcome.details.map(detail => (
          <Text key={detail} size="xs" c="dimmed">
            {detail}
          </Text>
        ))}
      </Box>
    </Group>
  );
}
